import clsx from 'clsx';
import { getExceedanceColor } from '@/utils/format';

interface ExceedanceBadgeProps {
  probability: number;
  size?: 'sm' | 'md' | 'lg';
  showLabel?: boolean;
}

export function ExceedanceBadge({
  probability,
  size = 'md',
  showLabel = false,
}: ExceedanceBadgeProps) {
  const sizeClasses = {
    sm: 'px-1.5 py-0.5 text-[10px]',
    md: 'px-2 py-0.5 text-xs',
    lg: 'px-2.5 py-1 text-sm',
  };

  const pct = `${Math.round(probability * 100)}%`;

  return (
    <span
      className={clsx(
        'inline-flex items-center font-medium tracking-wider border',
        getExceedanceColor(probability),
        sizeClasses[size]
      )}
    >
      {showLabel ? `P(exceed) ${pct}` : pct}
    </span>
  );
}
